import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Target, Flame, Beef, Wheat, Droplet } from 'lucide-react';

export function EditGoalsModal({
  isOpen,
  onClose,
  goals,
  onSave,
}) {
  const [editedGoals, setEditedGoals] = useState(goals);

  const handleSave = () => {
    onSave(editedGoals);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-slate-900 border-slate-800 text-white max-w-md">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <Target className="h-5 w-5 text-purple-400" />
            Daily Goals
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          {/* Calories */}
          <div className="space-y-2">
            <Label className="text-white flex items-center gap-2">
              <Flame className="h-4 w-4 text-orange-400" />
              Calories (kcal)
            </Label>
            <Input
              type="number"
              value={editedGoals.calories}
              onChange={(e) => setEditedGoals({ ...editedGoals, calories: Number(e.target.value) })}
              className="bg-slate-800 border-slate-700 text-white"
              min="500"
              max="10000"
            />
          </div>

          {/* Protein */}
          <div className="space-y-2">
            <Label className="text-white flex items-center gap-2">
              <Beef className="h-4 w-4 text-red-400" />
              Protein (g)
            </Label>
            <Input
              type="number"
              value={editedGoals.protein}
              onChange={(e) => setEditedGoals({ ...editedGoals, protein: Number(e.target.value) })}
              className="bg-slate-800 border-slate-700 text-white"
              min="0"
              max="500"
            />
          </div>

          {/* Carbs */}
          <div className="space-y-2">
            <Label className="text-white flex items-center gap-2">
              <Wheat className="h-4 w-4 text-yellow-400" />
              Carbs (g)
            </Label>
            <Input
              type="number"
              value={editedGoals.carbs}
              onChange={(e) => setEditedGoals({ ...editedGoals, carbs: Number(e.target.value) })}
              className="bg-slate-800 border-slate-700 text-white"
              min="0"
              max="1000"
            />
          </div>

          {/* Fat */}
          <div className="space-y-2">
            <Label className="text-white flex items-center gap-2">
              <Droplet className="h-4 w-4 text-blue-400" />
              Fat (g)
            </Label>
            <Input
              type="number"
              value={editedGoals.fat}
              onChange={(e) => setEditedGoals({ ...editedGoals, fat: Number(e.target.value) })}
              className="bg-slate-800 border-slate-700 text-white"
              min="0"
              max="500"
            />
          </div>

          {/* Save Button */}
          <Button
            onClick={handleSave}
            className="w-full bg-purple-600 hover:bg-purple-500"
          >
            Save Goals
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default EditGoalsModal;
